import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {KnockoutFieldComponent} from "../../core/components/knockout-field/knockout-field.component";
import {KnockoutFieldModel} from "../../core/components/knockout-field/knockout-field.model";
import {Subject, Subscription} from "rxjs";
import {RequestService} from "../../core/services/request/request.service";

@Component({
  selector: 'sb-permission-evaluation-page',
  templateUrl: './permission-evaluation-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./permission-evaluation-page.component.scss']
})
export class PermissionEvaluationPageComponent implements OnInit {

  constructor(private requestService: RequestService, private ref: ChangeDetectorRef) {
    ref.detach();
  }

  permissionCheckType: string = "role";

  // user: string = "c0a8011645fb1a608145fb3102b10000";
  // table: string = "c0a8016c680c132481680c93b51c00fc";
  // role: string = "c0a8016b673d1ebf81673d466b06016c";

  user: string;
  table: string;
  role: string;

  fields?: string;
  recordID?: string;

  includeTableIfFieldPresent: boolean = false;
  includeCreate: boolean = true;
  includeRead: boolean = true;
  includeUpdate: boolean = true;
  includeDelete: boolean = true;

  hideNotEvaluated: boolean = false;
  hideIgnored: boolean = false;

  data: any;
  checks: any[];
  userInfo: any;
  roleInfo: any;

  // Set up a mechanism for us to communicate with the child components (e.g. to ask for validation)
  eventsSubject: Subject<any> = new Subject<any>();


  permissionCheckTypeField: KnockoutFieldModel = {
    name: "PermissionCheckType",
    i18nKey: "Permission check type",
    datatype: 'choice',
    availableValues: [ // Why does this need displayValue: AND i18nKey: ?
      {value: 'role', displayValue: 'Role', i18nKey: 'Role'},
      {value: 'user', displayValue: 'User', i18nKey: 'User'}
    ],
    referenceTable: null,
    readonly: false,
    mandatory: true,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'role', displayValue: 'Role', i18nKey: 'Role'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "choice",
    rendererProperties: {},
    valueChangeCallback: (value) => {
      if (value !== undefined) {
        this.permissionCheckType = value;
        this.updateRequestData();
      }
    },
  };

  roleList = this.createSimpleKOReferenceFieldModel(
    'Role',
    'Role',
    null, // { value: "402881923a065eed013a06621fff0001", displayValue: "Andrew Venn" },
    (value) => {
      if (value !== undefined) {
        this.role = value;
        this.updateRequestData();
      }
    });

  userList = this.createSimpleKOReferenceFieldModel(
    'User',
    'User',
    null, // { value: "402881923a065eed013a06621fff0001", displayValue: "Andrew Venn" },
    (value) => {
      if (value !== undefined) {
        this.user = value;
        this.updateRequestData();
      }
    });

  tableList = this.createSimpleKOReferenceFieldModel(
    'TableDefinition',
    'Table',
    null, // { value: "c0a8016c680c132481680c93b51c00fc", displayValue: "Incident" },
    (value) => {
      if (value !== undefined) {
        this.table = value;
        this.updateRequestData();
      }
    });

  fieldInput = this.createSimpleKOTextFieldModel("Fields", null, (value) => { this.fields = value; this.updateRequestData(); });
  recordIDInput = this.createSimpleKOTextFieldModel("Record ID", null, (value) => { this.recordID = value; this.updateRequestData(); });

  getRowClasses(step): Map<string, boolean> {
    const result = new Map();

    result.set(step.action, true);
    result.set("hide_row", this.shouldHideRow(step));

    return result;
  }

  shouldHideRow(step): boolean {
    if (step.action === "NOT_EVALUATED" && this.hideNotEvaluated) {
      return true;
    } else if (step.action === "IGNORE" && this.hideIgnored) {
      return true;
    } else {
      return false;
    }

  }
  ngOnInit(): void {
    // Wipe out the page context
    (window as any).KO_PAGE_CONTEXT.clear();

    // Wipe out the Knockout content.
    const pageContentMain = document.getElementById("page-content-main");
    if (pageContentMain) {
      pageContentMain.innerHTML = "";
    }
    const errorConsole = document.getElementById("error-console");
    if (errorConsole) {
      errorConsole.innerHTML = "";
    }

    this.updateRequestData();
  }

  async updateRequestData() {
    console.debug("updateRequestData", this.includeCreate, this.includeRead);
    if (this.table != null && ((this.permissionCheckType === "user" && this.user != null) || (this.permissionCheckType === "role" && this.role != null))) {
      const data: any = await this.requestService.createRequest()
        .controller("servicely.core.Permissions")
        .method("evaluatePermissions")
        .data({
          checkType: this.permissionCheckType,
          role: this.role,
          user: this.user,
          table: this.table,
          record: this.recordID,
          fields: this.fields,
          includeCreate: this.includeCreate,
          includeRead: this.includeRead,
          includeUpdate: this.includeUpdate,
          includeDelete: this.includeDelete,
          includeTableIfFieldPresent: this.includeTableIfFieldPresent,
        })
        .execute();

      this.data = data['data'];
      this.checks = this.data["checks"];
      this.userInfo = this.data["user_info"];
      this.roleInfo = this.data["role_info"];
    }
    this.ref.detectChanges();
  }

  clickOnPermission(permissionID: string) {
    window['Navigate'].rightSlideInWindow(
      {
        'tile': 'DetailsAutoScaffold',
        'parameter-values': {
          table: "Permission",
          id: permissionID
        },
        'loadOptions' : {
          cache : false
        }
      },
      () => {
        this.updateRequestData();
      }
    );
  };

  createSimpleKOTextFieldModel(label: string, defaultValue: any, valueChangeCallback?: any): KnockoutFieldModel {
    return {
      name: 'String',
      i18nKey: label,
      datatype: 'text',
      availableValues: [],
      referenceTable: null,
      readonly: false,
      mandatory: false,
      enablePreview: false,
      tooltip: null,
      data: {
        defaultValue, // null | {value?: string, displayValue?: string };
        defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
        answer: {
          value: null,
          displayValue: null
        }, // null | {value?: string, displayValue?: string };
      },
      requestId: null,
      table: 'SyntheticTable',
      renderer: "textfield",
      rendererProperties: {},
      valueChangeCallback,
      keyupEventCallback: (fieldViewModel, event) => {}
    };
  }

  createSimpleKOReferenceFieldModel(tableName: string, label: string, defaultValue: any, valueChangeCallback?: any): KnockoutFieldModel {
    return {
      name: tableName,
      i18nKey: label,
      datatype: 'reference',
      availableValues: [],
      referenceTable: tableName,
      readonly: false,
      mandatory: true,
      enablePreview: false,
      tooltip: null,
      data: {
        defaultValue: defaultValue, // null | {value?: string, displayValue?: string };
        defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
        answer: {
          value: null,
          displayValue: null
        }, // null | {value?: string, displayValue?: string };
      },
      requestId: null,
      table: 'SyntheticTable',
      renderer: "onetoone",
      rendererProperties: {},
      valueChangeCallback: valueChangeCallback
    };
  }
}
